var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 11H8M7 11L6.14926 19.5074C6.06934 20.3066 6.69688 21 7.5 21V21C8.30312 21 8.93066 20.3066 8.85074 19.5074L8 11M7 11V11C5.34315 11 4 9.65685 4 8V6.5C4 4.567 5.567 3 7.5 3V3C9.433 3 11 4.567 11 6.5V8C11 9.65685 9.65685 11 8 11V11",
    stroke: "#687176",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 11L15.1493 19.5074C15.0693 20.3066 15.6969 21 16.5 21V21C17.3031 21 17.9307 20.3066 17.8507 19.5074L17 11M16 11H15.1378C13.9808 11 13.0652 10.0213 13.1422 8.86696L13.5 3.5M16 11H16.5M17 11H17.8622C19.0192 11 19.9348 10.0213 19.8578 8.86696L19.5 3.5M17 11H16.5M16.5 11V3.25",
    stroke: "#687176",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeals);
export default __webpack_public_path__ + "static/media/meals.871891bb127858d7908ce5a86cd16c82.svg";
export { ForwardRef as ReactComponent };